import React from 'react';
import './ImpactNumbers.css';

function ImpactNumbers() {
  return (
    <section className="impact-numbers">
      <h2>Our Early Milestones</h2>
      <div className="numbers-grid">
        {/* <div className="number-item">
          <h3>10+</h3>
          <p>Sectors Entered</p>
        </div> */}
        <div className="number-item">
          <h3>10+</h3>
          <p>Live Projects</p>
        </div>
        <div className="number-item">
          <h3>50+</h3>
          <p>Team Members</p>
        </div>
        <div className="number-item">
          <h3>100%</h3>
          <p>Startup Passion</p>
        </div>
      </div>
    </section>
  );
}

export default ImpactNumbers;
